import TableComponentContainer from "../../../../Components/Tables/ReactstrapTable/TableComponent/TableComponent"

const TableComponent = () => {
  return (
    <div className='page-body'>
      <TableComponentContainer />
    </div>
  )
}

export default TableComponent